// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fdVO","content":"styles_content__AXQGt","tableWrap":"styles_tableWrap__2q4Wp"};